export default __webpack_public_path__ + "static/media/pop.46eef402.svg";